import AgreementContract from "../abi/AgreementContract.json";
import Agreement from "../abi/Agreement.json";

const AgreementAddress = "0x8bB1b3C1e7AC49b3E3c099d0246d37b498c83633";
const biconomyAddress = "0x47829D7029Ab79382213d0d60B79A647bAEcd166";
const AgreementContractAbi = AgreementContract.abi;
const AgreementAbi = Agreement.abi;
const biconomyAbi = "";
const chainLinkPriceFeed = "0x149a76dD044b3C77fd2A8a193647Fd735Bcb4a0c";
const RandomNumberGeneratorContract =
  "0xd43030268316e36c55BA5F73C780d4bA02c2BF75";

const USDCx_Address = "0x42bb40bF79730451B11f6De1CbA222F17b87Afd7";
export {
  AgreementAddress,
  AgreementContractAbi,
  AgreementAbi,
  biconomyAddress,
  chainLinkPriceFeed,
  RandomNumberGeneratorContract,
  USDCx_Address
};
